import { render, staticRenderFns } from "./SuiteList.vue?vue&type=template&id=c87900ee&scoped=true&"
import script from "./SuiteList.vue?vue&type=script&lang=js&"
export * from "./SuiteList.vue?vue&type=script&lang=js&"
import style0 from "./SuiteList.vue?vue&type=style&index=0&id=c87900ee&prod&lang=scss&scoped=true&"
import style1 from "./SuiteList.vue?vue&type=style&index=1&id=c87900ee&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c87900ee",
  null
  
)

export default component.exports